// extracted by mini-css-extract-plugin
module.exports = {"tooltipButton":"TooltipButton_tooltipButton__37eII","tooltipButtonRed":"TooltipButton_tooltipButtonRed__KWI3A","maxWidth":"TooltipButton_maxWidth__KUord"};